module.exports = __webpack_public_path__ + "img/products-1.f8948709.jpg";